import React, { useState } from 'react';
import { Modal, Form, Input, Button, message } from 'antd';
import { addDoc, collection } from "firebase/firestore";
import { db } from '../../../firebaseConfig';
import './ItemModal.less';

const { TextArea } = Input;

const AddItemModal = ({ isVisible, onClose, fetchItems }: any) => {
    const [newItem, setNewItem] = useState({
        name: { en: '', zh: '' },
        shortDesc: { en: '', zh: '' },
        longDesc: { en: '', zh: '' },
        price: '',
        beforeDiscountPrice: '',
    });

    const handleAddItem = async () => {
        try {
            await addDoc(collection(db, "items"), newItem);
            setNewItem({
                name: { en: '', zh: '' },
                shortDesc: { en: '', zh: '' },
                longDesc: { en: '', zh: '' },
                price: '',
                beforeDiscountPrice: '',
            });
            onClose();
            fetchItems();
            message.success("Item added successfully!");
        } catch (error) {
            console.error("Error adding document: ", error);
            message.error("Error adding item!");
        }
    };

    return (
        <Modal
            title="Add New Item"
            open={isVisible}
            onCancel={onClose}
            footer={null}
        >
            <Form onFinish={handleAddItem} layout="vertical">
                {/* Name Fields */}
                <Form.Item label="Name (EN)" name="nameEn" rules={[{ required: true, message: 'Please input the English name!' }]}>
                    <Input
                        value={newItem.name.en}
                        onChange={(e) => setNewItem({ ...newItem, name: { ...newItem.name, en: e.target.value } })}
                    />
                </Form.Item>
                <Form.Item label="Name (ZH)" name="nameZh" rules={[{ required: true, message: 'Please input the Chinese name!' }]}>
                    <Input
                        value={newItem.name.zh}
                        onChange={(e) => setNewItem({ ...newItem, name: { ...newItem.name, zh: e.target.value } })}
                    />
                </Form.Item>

                {/* Short Description Fields */}
                <Form.Item label="Short Description (EN)" name="shortDescEn" rules={[{ required: true, message: 'Please input the English short description!' }]}>
                    <Input
                        value={newItem.shortDesc.en}
                        onChange={(e) => setNewItem({ ...newItem, shortDesc: { ...newItem.shortDesc, en: e.target.value } })}
                    />
                </Form.Item>
                <Form.Item label="Short Description (ZH)" name="shortDescZh" rules={[{ required: true, message: 'Please input the Chinese short description!' }]}>
                    <Input
                        value={newItem.shortDesc.zh}
                        onChange={(e) => setNewItem({ ...newItem, shortDesc: { ...newItem.shortDesc, zh: e.target.value } })}
                    />
                </Form.Item>

                {/* Long Description Fields */}
                <Form.Item label="Long Description (EN)" name="longDescEn" rules={[{ required: true, message: 'Please input the English long description!' }]}>
                    <TextArea
                        rows={4}
                        value={newItem.longDesc.en}
                        onChange={(e) => setNewItem({ ...newItem, longDesc: { ...newItem.longDesc, en: e.target.value } })}
                    />
                </Form.Item>
                <Form.Item label="Long Description (ZH)" name="longDescZh" rules={[{ required: true, message: 'Please input the Chinese long description!' }]}>
                    <TextArea
                        rows={4}
                        value={newItem.longDesc.zh}
                        onChange={(e) => setNewItem({ ...newItem, longDesc: { ...newItem.longDesc, zh: e.target.value } })}
                    />
                </Form.Item>

                {/* Price Field */}
                <Form.Item label="Price" name="price" rules={[{ required: true, message: 'Please input the price!' }]}>
                    <Input
                        value={newItem.price}
                        onChange={(e) => setNewItem({ ...newItem, price: e.target.value })}
                    />
                </Form.Item>

                {/* Discounted Price Field */}
                <Form.Item label="Before Discount Price" name="beforeDiscountPrice">
                    <Input
                        value={newItem.beforeDiscountPrice}
                        onChange={(e) => setNewItem({ ...newItem, beforeDiscountPrice: e.target.value })}
                    />
                </Form.Item>

                <Form.Item>
                    <div className="modal-buttons">
                        <Button onClick={onClose}>Cancel</Button>
                        <Button type="primary" htmlType="submit">
                            Add Item
                        </Button>
                    </div>
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default AddItemModal;
